import { Card, Col } from "react-bootstrap"
import { JCard, JCardBody, JTable, JTBody, JTHead } from "../../components/Components"
import { useEffect, useState } from "react"
import auxService from "../../services/AuxService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { useQuestion } from "../../components/ModalQuestion/useModalQuestion";
import { useModalMessage } from "../../components/ModalMessage/useModalMessage";

export const IndexCliente = () => {
    const [list, setList] = useState<any[]>([]);
    const { confirm, ConfirmModal } = useQuestion();
    const { alertModal, ModalMessageEl } = useModalMessage();

    const handleAtivar = async (id: string) => {

        
        const confirmed = await confirm({
            title: "Ativação",
            message: <>Confirma a ativação ?</>
        })

        if (confirmed) {
            auxService.ativarLicenca(id).then(res => {
                setList((prev) => prev.map((item: any) =>
                    item.id === id ? {
                        ...item,
                        active: 1
                    } : item)
                );
                alertModal("Registro removido com sucesso", "success");
            }).catch((error) => {
                
                alertModal("Erro ao ativar", "danger")
            })
        }
    }

    useEffect(() => {
        auxService.getClientes().then(res => {
            setList(res);
        }).catch(error => console.log(error));
    }, []);

    return (<div className="row d-flex justify-content-between align-items-start g-2">
        <Col md>
            <JCard>
                <Card.Header className="text-center fw-bold">
                    Lista de Clientes
                </Card.Header>
                <JCardBody>

                    <JTable>
                        <JTHead>
                            <tr>
                                <th className="text-center" style={{ width: '5rem' }}>Ações</th>
                                <th style={{ width: '11rem' }}>CNPJ</th>
                                <th style={{ width: '11rem' }}>Inscrição Estadual</th>
                                <th>Razão Social</th>
                                <th className="text-center" style={{ width: '11rem' }}>Data Cancelamento</th>
                                <th className="text-center" style={{ width: '11rem' }}>Situação</th>
                            </tr>
                        </JTHead>
                        <JTBody>
                            {list?.map((item: any) => {
                                return (<tr>
                                    <td className="text-center">
                                        {item.active === 0 && (
                                            <Link to={''}
                                                onClick={() => handleAtivar(item.id)}
                                                className=" text-success" title="Ativar cliente" >
                                                <FontAwesomeIcon icon={faCheck} />
                                            </Link>
                                        )}
                                    </td>
                                    <td>{item.cpfcnpj}</td>
                                    <td>{item.ie}</td>
                                    <td>{item.name}</td>
                                    <td>{item.data_cancelamento}</td>
                                    <td className="text-center">{item.active === 1 ? 'Ativo' : 'Inativo'}</td>
                                </tr>)
                            })}
                        </JTBody>
                    </JTable>
                </JCardBody>
            </JCard>
        </Col>
        {ConfirmModal}
        {ModalMessageEl}
    </div>)
}
